/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Frontrow_BookInputs */

const en_scene_frontrow_book = /** @type {(inputs: Scene_Frontrow_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book your visit`)
};

/**
* | output |
* | --- |
* | "Book your visit" |
*
* @param {Scene_Frontrow_BookInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const scene_frontrow_book = /** @type {((inputs?: Scene_Frontrow_BookInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Frontrow_BookInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_scene_frontrow_book(inputs)
});